export default __webpack_public_path__ + "static/B0164-79a5c6b7ffb959426ec842905b0a3f71.png";